<template>
  <div class="app-container">
    <el-tabs v-model="activeName" @tab-click="handleTabClick" style="margin-left: 8px;">
      <el-tab-pane label="汇总" name="huizong"> </el-tab-pane>
      <el-tab-pane label="中物系" name="zhongwu"> </el-tab-pane>
      <el-tab-pane label="兴瀚系" name="xinghan"> </el-tab-pane>
    </el-tabs>
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="90px" size="mini">
        <div class="formItemBox">
          <el-form-item label="项目名称:" >
            <el-select v-model="searchFrom.flowItemName" placeholder="请选择" size="mini">
              <el-option v-for="item in BMlist" :key="item.id" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年月:">
            <el-date-picker
              v-model="searchFrom.month"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              placeholder="请选择">
            </el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="子公司:">
            <el-select  v-model="searchFrom.createSubcompanyCode" filterable placeholder="请选择" @change="fzgsChange">
              <el-option v-for="item in zigsList" :label="item.companyName" :value="item.companyCode" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="部门名称:">
            <el-select v-model="searchFrom.createDepartmentCode" filterable placeholder="请选择" @change="buMenChange">
              <el-option v-for="item in FZbumenList" :label="item.name" :value="item.code" :key="item.id"></el-option>
            </el-select>
          </el-form-item> -->
        </div>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="searchFn" v-if="btnFlg[0]">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm('searchFrom')" v-if="btnFlg[1]">重置</el-button>
            <el-button type="primary" @click="exportFn" size="mini" :disabled="isDaoChu" v-if="btnFlg[2]">导出</el-button>
            <!-- <el-button type="primary" size="mini" @click="importFn">导入</el-button> -->
            <!-- <el-button type="primary" size="mini" @click="modelDown">模板下载</el-button> -->
          </div>
          <el-form-item style="margin-left:8px">
            <span class="margin0" >
              收入合计:<span class="red">{{sum.totalIncome}}</span>元&nbsp;&nbsp;&nbsp;&nbsp;
              支出合计:<span class="red">{{sum.totalExpenditure}}</span>元
            </span>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList" ref="table" v-loading="loading" bordersize="mini" @row-click="handleRowClick"
        style="width: 100%" height="100%" center border :key="tableKey" class="tableComent">
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <!-- <el-table-column prop="department" label="部门" align="center" width=""></el-table-column> -->
        <el-table-column prop="cashflowItem" label="现金流量项目" align="center" width="" show-overflow-tooltip></el-table-column>
        <el-table-column prop="income" label="收入(元)" align="center" ></el-table-column>
        <el-table-column prop="expenditure" label="支出(元)" align="center" ></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <!-- <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div> -->
    <!-- 导入 -->
    <importC v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat, toFixed } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { findCashFlowItemLists, statisticFaction, tFlowIncomeExpenditureDetailImport } from '@/api/common-signature'
import importC from '@/components/import.vue'
export default {
  components: {
    importC
  },
  data () {
    return {
      activeName: 'huizong',
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      tableList: [],
      BMlist: [],
      zigsList: [],
      FZbumenList: [],
      searchFrom: {
        month: this.getCurrentMonth()
        // pageNo: 1,
        // pageSize: 50
      },
      total: 0,
      loading: false,
      isDisable: false,
      sum: {},
      importDialog: false,
      tableKey: 0,
      btnFlg: [],
      btnIdArr: ['00FM0Z0100', '00FM0Z0200', '00FM0Z0300'],
      isDaoChu: false
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/cashFlowsOfEach')
    this.searchFn()
    this.findCashFlowItemLists()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 178) + 'px'
  },
  methods: {
    getCurrentMonth () {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      return `${year}-${month}`
    },
    tableRowClassName ({ row }) {
      if (row.isSummary) {
        return 'summary-row'
      }
      return ''
    },
    findCashFlowItemLists () {
      findCashFlowItemLists().then((res) => {
        if (res.length > 0) {
          this.BMlist = res
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 选择分子公司
    fzgsChange (e) {
      // let json = this.zigsList.find(itme => itme.companyCode == e)
      // this.$set(this.searchFrom, 'companyName', json.companyName)
      // this.$set(this.searchFrom, 'createDepartmentCode', null)
    },
    buMenChange (e) {
      let json = this.FZbumenList.find(itme => itme.code == e)
      this.$set(this.searchFrom, 'department', json.name)
    },
    // 导入
    importFn () {
      this.importDialog = true
    },
    // 导入模板下载
    modelDown () {
      var tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location = 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/tms/excel/现金流量项目收支明细导入模板.xlsx'// 后更改页面地址
    },
    DRsave (formData) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      tFlowIncomeExpenditureDetailImport(formData).then(res => {
        loading.close()
        this.importDialog = false
        var that = this
        that.msg = this.$message({
          showClose: true,
          message: res,
          duration: 3000,
          type: 'success',
          onClose () {

          }
        })
        that.getList(this.searchFrom)
      }).catch(err => {
        if (err.code == -1) {
          this.$message({
            type: 'warning',
            message: err.data ? err.data : err.message,
            onClose () {
              loading.close()
            }
          })
          this.isDisable = false
        } else {
          this.$message({
            type: 'error',
            message: err.data ? err.data : err.message,
            onClose () {
              loading.close()
            }
          })
          this.isDisable = false
        }
      })
    },
    destroy () {
      this.importDialog = false
    },
    handleTabClick (e) {
      this.tableKey += 1
      this.reinitializeTable()
      this.searchFn()
    },
    // 重新初始化表格（核心方法）
    reinitializeTable () {
      // 1. 清空表格数据
      this.tableData = []

      // 2. 重置分页状态
      // this.searchFrom = {}
    },
    // 导出
    exportFn () {
      this.searchFrom.tenantFaction = this.activeName == 'zhongwu' ? 0 : this.activeName == 'xinghan' ? '1' : ''
      let form = { ...this.searchFrom }
      // delete form.pageNo
      // delete form.pageSize
      exportExcel(
        this.global.smpName + '/tFlowIncomeExpenditureDetail/exportStatisticByFaction',
        form,
        this.activeName == 'zhongwu' ? '中物系部门现金流量表' : this.activeName == 'xinghan' ? '兴瀚系部门现金流量表' : '汇总表'
      )
      this.isDaoChu = true
      setTimeout(() => {
        this.isDaoChu = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      this.loading = true
      this.searchFrom.tenantFaction = this.activeName == 'zhongwu' ? 0 : this.activeName == 'xinghan' ? '1' : ''
      statisticFaction(this.searchFrom).then(res => {
        // 处理数据，添加合计行
        // const processedList = this.addSummaryRows(res.list)
        this.tableList = res.list
        // this.getSpanArr(processedList)
        // this.total = res.pageInfo.total
        this.sum = {
          totalExpenditure: res.totalExpenditure,
          totalIncome: res.totalIncome
        }
        this.loading = false
      })
    },
    // 添加合计行的方法
    addSummaryRows (data) {
      if (!data || data.length === 0) return data

      const result = []
      let i = 0

      while (i < data.length) {
        const currentDepartment = data[i].department
        let j = i
        let departmentIncome = 0
        let departmentExpenditure = 0

        // 计算当前部门的总收入和总支出
        while (j < data.length && data[j].department === currentDepartment) {
          departmentIncome += parseFloat(data[j].income) || 0
          departmentExpenditure += parseFloat(data[j].expenditure) || 0
          j++
        }

        // 添加原数据行
        for (let k = i; k < j; k++) {
          result.push({
            ...data[k],
            // 可以添加原始行标记
            isOriginalRow: true
          })
        }

        // 添加合计行（部门名称保留，用于合并）
        result.push({
          department: currentDepartment, // 保留部门名称用于合并
          cashflowItem: '合计',
          income: departmentIncome.toFixed(2),
          expenditure: departmentExpenditure.toFixed(2),
          isSummary: true // 标记为合计行
        })

        i = j
      }

      return result
    },
    // 生成合并规则数组
    getSpanArr (data) {
      this.spanArr = []
      if (data.length === 0) return

      let pos = 0
      data.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1)
          pos = 0
        } else {
          // 判断是否与上一行属于同一部门（包括合计行也一起合并）
          if (item.department === data[index - 1].department) {
            this.spanArr[pos] += 1
            this.spanArr.push(0)
          } else {
            this.spanArr.push(1)
            pos = index
          }
        }
      })
    },
    // 合并单元格
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // 部门列合并（包括合计行一起合并）
      if (columnIndex === 1) {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }

      // 现金流量项目列：如果是合计行，显示"合计"
      if (columnIndex === 2 && row.isSummary) {
        // 这里不需要特殊处理，因为数据中已经设置了 cashflowItem 为 "合计"
        return {
          rowspan: 1,
          colspan: 1
        }
      }
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        // pageNo: 1,
        // pageSize: 50
      }
      this.searchFn()
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
/deep/.el-form{
  width: 100%;
}
.tongjiBox{
   /deep/.el-form-item--mini .el-form-item__content,  /deep/.el-form-item--mini .el-form-item__label{
        line-height: 20px;
  }
}
/deep/.el-tabs__header{
  margin-bottom: 0;
}
.formItemBox{
  /deep/.el-form-item{
    width: 24%;
  }
}
/* 合计行加粗 */
/deep/.el-table .summary-row {
  font-weight: bold !important;
}

/deep/.el-table .summary-row td {
  font-weight: bold !important;
}
</style>
